var Backbone = require('backbone');
var _ = require('underscore');

var Index = require('front/pages/Index/Index');
var Article = require('front/pages/Article/Article');
var Search = require('front/pages/Search/Search');
var Category = require('front/pages/Category/Category');
var TagPage = require('front/pages/TagPage/TagPage');
var Author = require('front/pages/Author/Author');
var About = require('front/pages/About/About');
var Mag = require('front/pages/Mag/Mag');
var Privacy = require('front/pages/Privacy/Privacy');
var Broadcasts = require('front/pages/Broadcasts/Broadcasts');
var Casting = require('front/pages/Casting/Casting');
var Project = require('front/pages/Project/Project');
var Broadcast = require('front/pages/Broadcast/Broadcast');
var Archive = require('front/pages/Archive/Archive');
var Custom404 = require('front/pages/Custom404/Custom404');

module.exports = Backbone.Router.extend({
    routes: {
        '': 'index',
        ':articleId-:slug/': 'article',
        'search/': 'search',
        'hashtag/:slug/': 'tag',
        'author/:slug/': 'author',
        'efir/': 'broadcasts',
        'casting/': 'casting',
        'efir/archive/': 'archive',
        'efir/:slug/': 'project',
        'efir/:slug/:date-:slug/': 'broadcast'
    },

    initialize: function () {
        var categories = _.pluck(app.data.sections, 'linkName').join('|');
        var regex = new RegExp('^(' + categories + ')/$');
        this.route(regex, 'category');
    },

    index: function () {
        this.activate(Index);
    },

    article: function (articleId, slug) {
        this.activate(Article, {
            id: articleId,
            slug: slug
        });
    },

    search: function () {
        this.activate(Search);
    },

    category: function () {
        this.activate(Category);
    },

    tag: function () {
        this.activate(TagPage);
    },

    author: function () {
        this.activate(Author);
    },

    broadcasts: function () {
        this.activate(Broadcasts);
    },

    casting: function () {
        this.activate(Casting);
    },

    project: function () {
        this.activate(Project);
    },

    broadcast: function () {
        this.activate(Broadcast);
    },

    archive: function () {
        this.activate(Archive);
    },

    custom404: function () {
        this.activate(Custom404);
    },

    activate: function (view, params) {
        params = params || {};

        // вьюха отрендерена на сервере
        if (!app.state.view) {
            params.server = true;

            app.state.view = new view(params);
            app.state.view.activate();

            return;
        }

        app.state.prevView = app.state.view;

        this.activateStandardLogic(view, params);
    },

    // активация перехода с полной перезагрузкой и лоадером
    activateStandardLogic: function (view, params) {
        var newParams = _.defaults({server: false, inAnimated: true}, params);
        var newView = new view(newParams);
        var duration = params.fastNavigate ? 0 : ANIMATION_DURATION;

        return Promise.all([app.state.view.playOut({
            duration: duration,
            zoom: params.zoomNavigate,
            view: newView
        }), newView.loadData()])
            .then(function () {
                app.els.$content.css({minHeight: app.els.$content.height()});

                return app.state.view.deactivate({destroy: true});
            })
            .then(function () {
                app.state.isServer = false;
                app.state.view = newView;
                app.state.view.activate(newParams)
                    .then(function () {
                        app.els.$content.css({minHeight: ''});
                        $(window).scrollTop(0);

                        return app.state.view.playIn({
                            duration: duration,
                            zoom: params.zoomNavigate, view: newView
                        });
                    });
            });

    },

    start: function () {
        var is404 = app.els.$body.hasClass('Page404');
        var pushStateSupported = history && _.isFunction(history.pushState);
        Backbone.history.start({pushState: pushStateSupported, silent: is404});

        if (is404) {
            this.custom404();
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/Router.js
// module id = 148
// module chunks = 0